export class User {
  static entityName(plural = false) {
    return `Utilisateur${plural ? "s" : ""}`;
  }

  entityMessage() {
    return `L'utilisateur ${this.email}`;
  }

  constructor({
    id = null,
    agenceReference = { id: null },
    agences = [],
    contactFacturation = false,
    contactMiseAJour = false,
    contactSignataire = false,
    code = null,
    prenom = null,
    nom = null,
    nomComplet = null,
    email = null,
    fonction = null,
    numTel = null,
    active = true,
    locked = true,
    AD = null,
    admin = false,
    acces = [],
    dateFinMaj = null,
    commentaireMaj = null,
    adherent = {},
    persona = { id: null }
  } = {}) {
    this.id = id;
    this.agenceReference = agenceReference;
    this.agences = agences;

    this.contactFacturation = contactFacturation;
    this.contactMiseAJour = contactMiseAJour;
    this.contactSignataire = contactSignataire;

    this.code = code;

    this.prenom = prenom;
    this.nom = nom;
    this.nomComplet = nomComplet !== null ? nomComplet : `${prenom} ${nom}`;

    this.email = email;
    this.fonction = fonction;
    this.numTel = numTel;

    this.active = active;
    this.locked = locked;

    this.AD = AD;
    this.admin = admin;

    this.acces = acces;

    this.dateFinMaj = dateFinMaj;
    this.commentaireMaj = commentaireMaj;

    this.adherent = adherent;
    this.persona = persona;
  }
}
